import produce from 'immer';
import { SET_IS_LOADING_REDUCER, SET_LOADING_AUTH_REDUCER } from './actionTypes';

export interface IStatusState {
  isLoading: boolean;
  isLoadingAuth: boolean;
}

const initialState: IStatusState = {
  isLoading: false,
  isLoadingAuth: true,
};

export const statusReducer = (state: IStatusState = initialState, action: { type: string; data: any }) =>
  produce(state, (draft) => {
    switch (action?.type) {
      case SET_IS_LOADING_REDUCER:
        draft.isLoading = action?.data;
        break;
      case SET_LOADING_AUTH_REDUCER:
        draft.isLoadingAuth = action?.data;
        break;
      default:
        return state;
    }
  });
